<template>
    <st-modal
        id="decision-modal"
        hide-header-delimiter
        hide-footer-delimiter
        hide-footer
        hideable
        :noCloseOnBackdrop="true"
        size="lg"
        ref="modal"
        customClass="form-modal"
    >
        <template #header>
            <p class="font-size-h5 font-weight-bold mb-0 pb-0">
                {{ $t("DECISION.ADD_EDIT_FORM.HEADER_ADD") }}
            </p>
        </template>
        <template #body>
            <application-decision-form
                :item="item"
                @submitForm="submit"
                @cancelForm="cancel"
            ></application-decision-form>
        </template>
    </st-modal>
</template>

<script>
import ApplicationDecisionForm from "@/modules/applications/components/decision/ApplicationDecisionForm";

export default {
    name: "ApplicationDecisionModal",
    props: {
        item: {
            type: Object,
            required: false,
        },
    },
    components: {
        ApplicationDecisionForm,
    },
    methods: {
        hide() {
            this.$refs["modal"].hide();
        },
        show() {
            this.$refs["modal"].show();
        },
        submit(data) {
            this.$emit("processDecision", data);
            this.hide();
        },
        cancel() {
            this.$emit("cancel");
            this.hide();
        },
    },
};
</script>
